<template>
    <span class="avator-container">
        <Avatar :src="src" v-if="src!=null"/>
        <Avatar v-else>{{text}}</Avatar>
        <Badge :status="status"  />
    </span>
</template>

<script>
export default {
    /**
     * status 用户在线，离线状态
     * shape  状态符号形状
     * 
     */
    props:{
        status:{type:String,default:'processing'},
        shape:{type:String,default:'circle'},
        src:{type:String,default: null},
        text:{type:String,default:'user'}
    }
}
</script>
